import { useScreenMessage } from '@gogame/screens';

import { validatePromoCode } from 'scenes/PromoCodes/sources/promoCodes';

export const useValidatePromoCode = () => {
  const { showErrorMessage } = useScreenMessage();
  return ({ id, value }) => {
    return validatePromoCode({ id, value }).catch(e => {
      showErrorMessage(e.message);
      return Promise.reject(e);
    });
  };
};
